import type { FleetOverviewParams } from '@si/types';
import { fleetOverviewResponseSchema } from '@si/types';
import { get, objectToQueryParams } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import { queryKeys } from './queryKeys';
import { useUser } from './useUser';

export function useFleetOverview(params: FleetOverviewParams, refreshInterval: number | false) {
  const { user } = useUser();
  return useQuery({
    queryKey: queryKeys.getFleetOverview(params),
    queryFn: ({ signal }) =>
      get({
        url: `/admin/fleet-overview${objectToQueryParams({ ...params, limit: params.section === 'projects' ? 10 : 50 })}`,
        schema: fleetOverviewResponseSchema,
        signal,
      }),
    enabled: !!user?.isSiAdmin,
    staleTime: 60_000,
    refetchInterval: (query) =>
      isAxiosError(query.state.error) &&
      [401, 403].includes(query.state.error.response?.status ?? 0)
        ? false
        : refreshInterval,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    retry: (failures, error) =>
      !(isAxiosError(error) && [401, 403].includes(error.response?.status ?? 0)) && failures < 1,
  });
}
